import { ImageComponent as BaseImage } from './Image'
import { Source } from './Source'

export type { ImageProps } from './types'

export const Image = Object.assign(BaseImage, { Source })
